@if (loading) {
  <app-loading [type]="-1" [size]="'50px'" [style]="{'margin-top': '50px'}"></app-loading>
}
@if (loading) {
  <div>
    <br/>
    <br/>
    <br/>
    <br/>
  </div>
}
<a class="twitter-timeline" href="https://twitter.com/mediasignage?ref_src=twsrc%5Etfw">
</a>
